import { View } from '@play-co/timestep-core/ui';
import { ToggleSwitcher } from 'src/game/components/shared/ToggleSwitcher';
import { SettingsKey } from '../popup/PopupSettings';
import sounds from 'src/lib/sounds';
import StateObserver from 'src/StateObserver';

type SettingsToggleSwitcherKey = Extract<SettingsKey, 'music' | 'sound'>;
type SettingsToggleSwitcherOpts = {
  superview: View;
  type: SettingsToggleSwitcherKey;
  onToggle: (value: boolean) => void | Promise<void>;
  isOn: boolean;
};

export class SettingsToggleSwitcher extends ToggleSwitcher {
  private opts: SettingsToggleSwitcherOpts;

  constructor(opts: SettingsToggleSwitcherOpts) {
    super({
      superview: opts.superview,
      content: {
        active: 'settings.on',
        inactive: 'settings.off',
      },
      onToggle: async (value) => {
        sounds.sfx.play('ok');
        await this.handleSettingChange(value);
      },
      tracking: {
        feature: 'settings',
        $subFeature: `popup-settings-${opts.type}`,
      },
      isOn: opts.isOn,
    });

    this.opts = opts;
  }

  private async handleSettingChange(value: boolean): Promise<void> {
    switch (this.opts.type) {
      case 'music':
        sounds.musicMuted = !value;
        break;
      case 'sound':
        sounds.sfxMuted = !value;
        break;
    }

    this.opts.onToggle(value);

    await StateObserver.invoke.updateSettings({
      [this.opts.type]: value,
    });
  }
}
